import useSWR from 'swr';
import { parseErrorResponse } from './problem';

export interface Permission {
  id: string;
  project_id?: string;
  project_slug?: string;
  user_email?: string;
  group_name?: string;
  role: 'reader' | 'developer' | 'maintainer' | 'project_admin' | 'org_admin';
}

// A refused list (403/401/5xx) must reject so SWR sets `error` instead of
// handing the problem+json body to callers as if it were the data.
const fetcher = async (url: string) => {
  const r = await fetch(url, { credentials: 'include' });
  if (!r.ok) throw await parseErrorResponse(r);
  return r.json();
};

export function usePermissions(projectId?: string) {
  const qs = projectId ? `?project_id=${projectId}` : '';
  return useSWR<Permission[]>(`/api/admin/permissions${qs}`, fetcher);
}

export interface ScimGroup {
  id: string;
  name: string;
  member_count: number;
}

export function useScimGroups() {
  return useSWR<ScimGroup[]>('/api/admin/permissions/groups', fetcher);
}

export async function createPermission(p: {
  project_id?: string | null;
  user_email?: string;
  group_name?: string;
  role: Permission['role'];
}): Promise<void> {
  const res = await fetch('/api/admin/permissions', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(p),
  });
  if (!res.ok) throw await parseErrorResponse(res);
}

export async function deletePermission(id: string): Promise<void> {
  const res = await fetch(`/api/admin/permissions/${id}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  if (!res.ok && res.status !== 204) throw await parseErrorResponse(res);
}
